import React, { useEffect, useState } from "react";
import { Avatar, Box, Chip, makeStyles } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import AppColor from "utilities/AppColor";
import PropTypes from "prop-types";
import classNames from "classnames";
import { CopyToClipboard } from 'react-copy-to-clipboard';

import AccountIcon from "assets/icons/user-circle-regular.svg";
import AppButton from "components/CustomButtons/AppButton";
import { Rating } from "@material-ui/lab";
import { useHistory } from "react-router-dom";
import { BOOKING_STATUS } from "config/AppConfig";
import AppConfirmDialog from "components/Dialog/AppConfirmDialog";
import { useDispatch } from "react-redux";

import { showToast } from "store/slices/toast";

import MorningIcon from "assets/icons/morning.svg";
import AfternoonIcon from "assets/icons/afternoon.svg";
import EveningIcon from "assets/icons/evening.svg";
import NightIcon from "assets/icons/night.svg";
import {
  fetchAccreditation
} from "store/slices/worker";
import { WORKER_TYPE } from "config/AppConfig";
import { reduceCancelBooking, reduceUpdateEndBooking, approvalExpressInterest } from "store/slices/booking";
import moment from "moment";
import AppUtil from "utilities/AppUtil";



const JobUserTag = (props) => {
  const {
    userInfo,
    onAdd,
    onRemove,
    isApplied,
    isSearching,
    isBooking,
    isCalendar,
    isBooked,
    isCancel,
    setReload,
    isDisableButtonBook,
    isDisable,
    isEndBooking,
    bookingInfo,
    isBookingPopup
  } = props;
  const { t } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();
  const isMobile = AppUtil.mobileAndTabletCheck();

  const [loading, setLoading] = useState(false);
  const [showConfirmRemove, setShowConfirmRemove] = useState(false);
  const [url, setUrl] = useState('');
  const [accreditations, setAccreditations] = useState([]);
  const [showConfirmCancel, setShowConfirmCancel] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showConfirmEndBooking, setShowConfirmEndBooking] = useState(false);
  const [showConfirmApprove, setShowConfirmApprove] = useState(false);
  const [showConfirmReject, setShowConfirmReject] = useState(false);
  const {
    // avatar,
    avatarAws3Link,
    firstName,
    lastName,
    point,
    distance,
    accreditationId,
    rating = 0,
    description,
    jobId,
    booked,
    id,
    bookingStatus,
    time,
    shiftType,
    bookingId
  } = userInfo;

  const name = `${firstName || ''} ${lastName || ''}`;
  const imgSrc = avatarAws3Link ? avatarAws3Link : AccountIcon;

  const bookingColor = {
    'BOOKED': { border: AppColor.green, background: '#EBF1ED' },
    'ON_GOING': { border: AppColor.violet, background: '#EFE7EF' },
    'CANCEL': { border: AppColor.red, background: '#F3E9E9' },
    'DONE': { border: AppColor.blue, background: '#EFF3F8' },
    'WAITING': { border: AppColor.orange, background: '#F3EAE1' },
    'EXPRESS_INTEREST': { border: AppColor.pink, background: '#FFF5F5' }
  };
  console.log('isDisable', isDisable);
  const styles = makeStyles(() => ({
    large: {
      width: '100%',
      height: '100%'
    },
    wrapTag: {
      border: '1px solid rgba(0, 0, 0, 0.2)',
      boxShadow: '0px 4px 4px rgb(0 0 0 / 25%)',
      borderRadius: 4,
      padding: '0.5rem',
      margin: '0.5rem 0',
      display: 'flex',
      flexDirection: 'column',
      height: '100%'
    },
    wrapAvatar: {
      padding: '0.5rem',
      minWidth: 100,
      minHeight: 100,
      width: 100,
      height: 100,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },
    tagBody: {
      display: 'flex',
      height: '100%'
    },
    tagBodyMobile: {
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      alignItems: 'center'
    },
    wrapInfo: {
      flex: '1 0 0px'
    },
    tagName: {
      fontSize: '1.2rem',
      fontWeight: 700
    },
    tagNameMobile: {
      fontSize: '1.2rem',
      fontWeight: 700,
      textAlign: 'center'
    },
    bold: {
      fontWeight: 700
    },
    statusBooked: {
      color: AppColor.green
    },
    wrapSearch: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'flex-end',
      wordBreak: 'break-word'
    },
    leftInfo: {
      flex: '1 0 0px'
    },
    disabled: {
      pointerEvents: 'none'
    },
    rightInfo: {
      textAlign: 'right'
    },
    rating: {
      color: AppColor.mainColor
    }
  }));

  const classes = styles();

  useEffect(() => {
    const origin = window.location.origin;
    const hash = window.location.hash !== '' ? '#' : '';

    setUrl(origin + '/' + hash);
    loadAccreditations(WORKER_TYPE.NURSE);
  }, []);

  const displayTime = () => {
    let title = time && (time !== undefined || time !== null || time !== '') && time.split(" ");
    if (title) {
      title[0] = moment(title[0]).format('DD-MM-yyyy');
      return title.join(' ');
    }

  }

  const _getLink = () => {
    dispatch(showToast({
      type: 'success',
      message: t('label.copied_to_clipboard')
    }))
  };
  const loadAccreditations = async (workerType) => {
    const result = await dispatch(fetchAccreditation({ workerType: workerType }));
    if (result.payload) {
      setAccreditations(result.payload);
    }
  };
  const renderShiftIcon = (shift) => {
    let iconComponent;
    switch (shift) {
      case 'MORNING':
        iconComponent = MorningIcon;
        break
      case 'AFTERNOON':
        iconComponent = AfternoonIcon;
        break
      case 'EVENING':
        iconComponent = EveningIcon;
        break
      case 'NIGHT':
        iconComponent = NightIcon;
        break
      default:
        iconComponent = MorningIcon;
        break;
    }
    return <img
      src={iconComponent}
      className={classNames({
        [classes.itemIcon]: true
      })}
    />;
  };
  const renderAccreditation = (accrId) => {
    let accreditation;
    const nurseAccreditation = accreditations.map(item => {
      return {
        value: item.id,
        label: item.name
      }
    });
    for (const key in nurseAccreditation) {
      if (accrId === nurseAccreditation[key].id) {
        accreditation = t(nurseAccreditation[key].label);
      }
    }
    return (<span className={classes.bold}>{accreditation}</span>)
  };
  const redirectProfile = () => {
    history.push(`/public/worker-profile/${id}`);
  }

  const renderTagApplied = () => (
    <React.Fragment>
      <Box className={classes.tagName}>{name}</Box>
      <Box>
        <AppButton
          label={`${t("label.viewProfile")}`}
          onClick={redirectProfile}
          buttonColor={AppColor.pink}
        />
      </Box>
      <Box>
        {
          renderAccreditation(accreditationId)
        }
      </Box>
      <Box>
        <span>{`${t('label.status')}: `}</span>
        <span
          className={classNames({
            [classes.bold]: true,
            [classes.statusBooked]: isBooked
          })}
        >{`${isBooked ? t("button.booked") : t("label.available")}`}</span>
      </Box>
    </React.Fragment>
  );
  const renderTagSearching = () => (
    isMobile ?
      <Box className={classes.wrapSearch}>
        <Box style={{ textAlign: 'center' }}>
          <Box className={classes.tagName}>{name}</Box>
          <Box>
            <Rating
              name="read-only"
              value={parseFloat(rating.toFixed(1))}
              className={classes.rating}
              readOnly
              precision={0.1}
            />
          </Box>
          <Box>{t('label.point_value', { value: point })}</Box>
          <Box><i className="fas fa-map-marker-alt"></i>{t('label.distanceKm', { value: parseFloat((distance / 1000)).toFixed(2) })}</Box>
          <Box style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <AppButton
              className='mr-1 mb-1'
              label={`${t("label.viewProfile")}`}
              buttonColor={AppColor.pink}
              onClick={redirectProfile}
            />
            {
              ((jobId && isSearching) || (booked && isBooking))
                ? (
                  <AppButton
                    label={isBooking ? t("button.booked") : t("button.added")}
                    rounder
                    buttonColor={AppColor.greyDark}
                    onClick={() => handleAddWorker(userInfo)}
                    className={classes.disabled}
                    disabled={loading || isDisable}
                    loading={loading}
                  />
                )
                : (
                  <AppButton
                    label={isBooking ? t("button.book") : t("button.add")}
                    rounder
                    onClick={() => handleAddWorker(userInfo)}
                    disabled={loading || (isDisableButtonBook && isBooking) || isDisable}
                    loading={loading}
                  />
                )
            }
          </Box>
          <Box>
            {
              renderAccreditation(accreditationId)
            }
          </Box>
          <Box>{description}</Box>
        </Box>

      </Box>
      :
      <Box className={classes.wrapSearch}>
        <Box className={classes.leftInfo}>
          <Box className={classes.tagName}>{name}</Box>
          <Box>
            <AppButton
              className='mr-1'
              label={`${t("label.viewProfile")}`}
              buttonColor={AppColor.pink}
              onClick={redirectProfile}
            />
            {
              ((jobId && isSearching) || (booked && isBooking))
                ? (
                  <AppButton
                    label={isBooking ? t("button.booked") : t("button.added")}
                    rounder
                    buttonColor={AppColor.greyDark}
                    onClick={() => handleAddWorker(userInfo)}
                    className={classes.disabled}
                    disabled={loading || isDisable}
                    loading={loading}
                  />
                )
                : (
                  <AppButton
                    label={isBooking ? t("button.book") : t("button.add")}
                    rounder
                    onClick={() => handleAddWorker(userInfo)}
                    disabled={loading || (isDisableButtonBook && isBooking) || isDisable}
                    loading={loading}
                  />
                )
            }
          </Box>
          <Box>
            {
              renderAccreditation(accreditationId)
            }
          </Box>
          <Box>{description}</Box>
        </Box>
        <Box className={classes.rightInfo}>
          <Box><Rating
            name="read-only"
            value={parseFloat(rating.toFixed(1))}
            className={classes.rating}
            readOnly
            precision={0.1}
          /></Box>
          <Box>{t('label.point_value', { value: point })}</Box>
          <Box><i className="fas fa-map-marker-alt"></i>{t('label.distanceKm', { value: parseFloat((distance / 1000)).toFixed(2) })}</Box>
        </Box>
      </Box>
  );
  const renderTagCalendar = () => (
    <Box className={classes.wrapSearch}>
      <Box className={classes.leftInfo}>
        <Box className={classes.tagName}>{name}</Box>
        <Box>
          {
            renderAccreditation(accreditationId)
          }
        </Box>
        <Box display="flex" justifyContent="space-between">
          <span>
            <span className={classes.bold}>{`${t('label.time')}: `}</span>
            <span>{displayTime()}</span>
          </span>
          <span>{renderShiftIcon && renderShiftIcon(shiftType)}</span>
        </Box>
        <Box>
          <span className={classes.bold}>
            {`${t('label.status')}: `}
          </span>
          <Chip
            style={{
              backgroundColor: BOOKING_STATUS.BOOKED === bookingStatus
                ? AppColor.green
                : BOOKING_STATUS.WAITING === bookingStatus
                  ? AppColor.orange
                  : BOOKING_STATUS.ON_GOING === bookingStatus
                    ? AppColor.violet
                    : BOOKING_STATUS.CANCEL === bookingStatus
                      ? AppColor.red
                      : BOOKING_STATUS.DONE === bookingStatus
                        ? AppColor.blue
                        : BOOKING_STATUS.NO_CLOCK_IN === bookingStatus
                          ? AppColor.yellow
                          : BOOKING_STATUS.EXPRESS_INTEREST === bookingStatus
                            ? AppColor.pink
                            : AppColor.grey,
              color: AppColor.white
            }}
            size="small"
            label={t(`bookingStatus.${bookingStatus}`)}
          />
        </Box>
      </Box>
    </Box>
  );

  const renderTagCancel = () => (
    !isCalendar ?
      isMobile ?
        <Box className={classes.wrapSearch}>
          <Box>
            <Box className={classes.tagNameMobile}>{name}</Box>
            <Box>
              {
                renderAccreditation(accreditationId)
              }
            </Box>
            <Box display="flex" justifyContent="space-between">
              <span>
                <span className={classes.bold}>{`${t('label.time')}: `}</span>
                <span>{displayTime()}</span>
              </span>
              <span>{renderShiftIcon && renderShiftIcon(shiftType)}</span>
            </Box>
            <Box>
              <span className={classes.bold}>
                {`${t('label.status')}: `}
              </span>
              <Chip
                style={{
                  backgroundColor: BOOKING_STATUS.BOOKED === bookingStatus
                    ? AppColor.green
                    : BOOKING_STATUS.WAITING === bookingStatus
                      ? AppColor.orange
                      : BOOKING_STATUS.ON_GOING === bookingStatus
                        ? AppColor.violet
                        : BOOKING_STATUS.CANCEL === bookingStatus
                          ? AppColor.red
                          : BOOKING_STATUS.DONE === bookingStatus
                            ? AppColor.blue
                            : BOOKING_STATUS.NO_CLOCK_IN === bookingStatus
                              ? AppColor.yellow
                              : BOOKING_STATUS.EXPRESS_INTEREST === bookingStatus
                                ? AppColor.pink
                                : AppColor.grey,
                  color: AppColor.white
                }}
                size="small"
                label={t(`bookingStatus.${bookingStatus}`)}
              />
              <Box style={{
                marginTop: 10,
                textAlign: 'left'
              }}>
                {bookingStatus === BOOKING_STATUS.EXPRESS_INTEREST ? (
                  <>
                    <AppButton
                      className='mr-1'
                      label={`${t("button.approve")}`}
                      buttonColor={AppColor.mainColor}
                      onClick={() => setShowConfirmApprove(true)}
                      isLoading={isLoading}
                      disabled={isLoading}
                    />
                    <AppButton
                      className='mr-1'
                      label={`${t("button.reject")}`}
                      buttonColor={AppColor.red}
                      onClick={() => setShowConfirmReject(true)}
                      isLoading={isLoading}
                      disabled={isLoading}
                    />
                  </>
                ) : (
                  <AppButton
                    className='mr-1'
                    label={`${t("button.cancelBooking")}`}
                    buttonColor={AppColor.pink}
                    onClick={() => setShowConfirmCancel(true)}
                    isLoading={isLoading}
                    disabled={isLoading}
                  />
                )}
              </Box>
            </Box>
          </Box>
        </Box>
        :
        <Box className={classes.wrapSearch}>
          <Box className={classes.leftInfo}>
            <Box className={classes.tagName}>{name}</Box>
            <Box>
              {
                renderAccreditation(accreditationId)
              }
            </Box>
            <Box display="flex" justifyContent="space-between">
              <span>
                <span className={classes.bold}>{`${t('label.time')}: `}</span>
                <span>{displayTime()}</span>
              </span>
              <span>{renderShiftIcon && renderShiftIcon(shiftType)}</span>
            </Box>
            <Box>
              <span className={classes.bold}>
                {`${t('label.status')}: `}
              </span>
              <Chip
                style={{
                  backgroundColor: BOOKING_STATUS.BOOKED === bookingStatus
                    ? AppColor.green
                    : BOOKING_STATUS.WAITING === bookingStatus
                      ? AppColor.orange
                      : BOOKING_STATUS.ON_GOING === bookingStatus
                        ? AppColor.violet
                        : BOOKING_STATUS.CANCEL === bookingStatus
                          ? AppColor.red
                          : BOOKING_STATUS.DONE === bookingStatus
                            ? AppColor.blue
                            : BOOKING_STATUS.NO_CLOCK_IN === bookingStatus
                              ? AppColor.yellow
                              : BOOKING_STATUS.EXPRESS_INTEREST === bookingStatus
                                ? AppColor.pink
                                : AppColor.grey,
                  color: AppColor.white
                }}
                size="small"
                label={t(`bookingStatus.${bookingStatus}`)}
              />
              <Box style={{
                marginTop: 10,
                textAlign: 'right'
              }}>
                {bookingStatus === BOOKING_STATUS.EXPRESS_INTEREST ? (
                  <>
                    <AppButton
                      className='mr-1'
                      label={`${t("button.approve")}`}
                      buttonColor={AppColor.mainColor}
                      onClick={() => setShowConfirmApprove(true)}
                      isLoading={isLoading}
                      disabled={isLoading}
                    />
                    <AppButton
                      className='mr-1'
                      label={`${t("button.reject")}`}
                      buttonColor={AppColor.red}
                      onClick={() => setShowConfirmReject(true)}
                      isLoading={isLoading}
                      disabled={isLoading}
                    />
                  </>
                ) : (
                  <AppButton
                    className='mr-1'
                    label={`${t("button.cancelBooking")}`}
                    buttonColor={AppColor.pink}
                    onClick={() => setShowConfirmCancel(true)}
                    isLoading={isLoading}
                    disabled={isLoading}
                  />
                )}
              </Box>
            </Box>
          </Box>
        </Box>
      :
      <Box className={classes.rightInfo}>
        {bookingStatus === BOOKING_STATUS.EXPRESS_INTEREST ? (
          <>
            <AppButton
              className='mr-1'
              label={`${t("button.approve")}`}
              buttonColor={AppColor.mainColor}
              onClick={() => setShowConfirmApprove(true)}
              isLoading={isLoading}
              disabled={isLoading}
            />
            <AppButton
              className='mr-1'
              label={`${t("button.reject")}`}
              buttonColor={AppColor.red}
              onClick={() => setShowConfirmReject(true)}
              isLoading={isLoading}
              disabled={isLoading}
            />
          </>
        ) : (
          <AppButton
            className='mr-1'
            label={`${t("button.cancelBooking")}`}
            buttonColor={AppColor.pink}
            onClick={() => setShowConfirmCancel(true)}
            isLoading={isLoading}
            disabled={isLoading}
          />
        )}
      </Box>
  )

  const renderTagEndBooking = () => (
    !isCalendar ?
    isMobile ?
    <Box className={classes.wrapSearch}>
    <Box>
      <Box className={classes.tagNameMobile}>{name}</Box>
      <Box>
        {
          renderAccreditation(accreditationId)
        }
      </Box>
      <Box display="flex" justifyContent="space-between">
        <span>
          <span className={classes.bold}>{`${t('label.time')}: `}</span>
          <span>{displayTime()}</span>
        </span>
        <span>{renderShiftIcon && renderShiftIcon(shiftType)}</span>
      </Box>
      <Box>
        <span className={classes.bold}>
          {`${t('label.status')}: `}
        </span>
        <Chip
          style={{
            backgroundColor: BOOKING_STATUS.BOOKED === bookingStatus
              ? AppColor.green
              : BOOKING_STATUS.WAITING === bookingStatus
                ? AppColor.orange
                : BOOKING_STATUS.ON_GOING === bookingStatus
                  ? AppColor.violet
                  : BOOKING_STATUS.CANCEL === bookingStatus
                    ? AppColor.red
                    : BOOKING_STATUS.DONE === bookingStatus
                      ? AppColor.blue
                      : BOOKING_STATUS.NO_CLOCK_IN === bookingStatus
                        ? AppColor.yellow
                        : BOOKING_STATUS.EXPRESS_INTEREST === bookingStatus
                          ? AppColor.pink
                          : AppColor.grey,
            color: AppColor.white
          }}
          size="small"
          label={t(`bookingStatus.${bookingStatus}`)}
        />
        <Box style={{
          marginTop: 10,
          textAlign: 'left'
        }}>
          {
            moment(moment(bookingInfo.endTime)).diff(moment(new Date())) > 0 &&
            <AppButton
              className='mr-1'
              label={`${t("button.endBooking")}`}
              // buttonColor={AppColor.pink}
              onClick={() => setShowConfirmEndBooking(true)}
              isLoading={isLoading}
              disabled={isLoading}
            />
          }
        </Box>
      </Box>
    </Box>
  </Box>
    :
      <Box className={classes.wrapSearch}>
        <Box className={classes.leftInfo}>
          <Box className={classes.tagName}>{name}</Box>
          <Box>
            {
              renderAccreditation(accreditationId)
            }
          </Box>
          <Box display="flex" justifyContent="space-between">
            <span>
              <span className={classes.bold}>{`${t('label.time')}: `}</span>
              <span>{displayTime()}</span>
            </span>
            <span>{renderShiftIcon && renderShiftIcon(shiftType)}</span>
          </Box>
          <Box>
            <span className={classes.bold}>
              {`${t('label.status')}: `}
            </span>
            <Chip
              style={{
                backgroundColor: BOOKING_STATUS.BOOKED === bookingStatus
                  ? AppColor.green
                  : BOOKING_STATUS.WAITING === bookingStatus
                    ? AppColor.orange
                    : BOOKING_STATUS.ON_GOING === bookingStatus
                      ? AppColor.violet
                      : BOOKING_STATUS.CANCEL === bookingStatus
                        ? AppColor.red
                        : BOOKING_STATUS.DONE === bookingStatus
                          ? AppColor.blue
                          : BOOKING_STATUS.NO_CLOCK_IN === bookingStatus
                            ? AppColor.yellow
                            : BOOKING_STATUS.EXPRESS_INTEREST === bookingStatus
                              ? AppColor.pink
                              : AppColor.grey,
                color: AppColor.white
              }}
              size="small"
              label={t(`bookingStatus.${bookingStatus}`)}
            />
            <Box style={{
              marginTop: 10,
              textAlign: 'right'
            }}>
              {
                moment(moment(bookingInfo.endTime)).diff(moment(new Date())) > 0 &&
                <AppButton
                  className='mr-1'
                  label={`${t("button.endBooking")}`}
                  // buttonColor={AppColor.pink}
                  onClick={() => setShowConfirmEndBooking(true)}
                  isLoading={isLoading}
                  disabled={isLoading}
                />
              }
            </Box>
          </Box>
        </Box>
      </Box>
      :
      <Box className={classes.rightInfo}>
        <AppButton
          className='mr-1'
          label={`${t("button.endBooking")}`}
          // buttonColor={AppColor.pink}
          onClick={() => setShowConfirmEndBooking(true)}
          isLoading={isLoading}
          disabled={isLoading}
        />
      </Box>
  )

  const onClickRemoveWorker = () => {
    setShowConfirmRemove(true);
  };
  const onConfirmRemoveWorker = () => {
    onRemove && handleRemoveWorker({ workerId: id });
    setShowConfirmRemove(false)
  }

  const handleAddWorker = async (data) => {
    setLoading(true);
    await onAdd(data);
    setLoading(false);
  }
  const handleRemoveWorker = async (data) => {
    setLoading(true);
    await onRemove(data);
    setReload && setReload(true);
    setLoading(false);
  }

  const onConfirmCancelBooking = async () => {
    setShowConfirmCancel(false);
    setIsLoading(true);
    const result = await dispatch(reduceCancelBooking({ bookingId: bookingId }));
    setIsLoading(false);
    const { payload } = result;
    if (payload) {
      setReload && setReload(true);
    }
  }

  const onConfirmEndBooking = async () => {
    setShowConfirmCancel(false);
    setIsLoading(true);
    const realTime = moment();
    const realEndTimeStr = moment(realTime).format('YYYY/MM/DD HH:mm:ss');
    const result = await dispatch(reduceUpdateEndBooking({ bookingId: bookingId, realEndTimeStr: realEndTimeStr }));
    setIsLoading(false);
    const { payload } = result;
    if (payload) {
      setReload && setReload(true);
    }
  }

  const onConfirmApproveInterest = async () => {
    setShowConfirmApprove(false);
    setIsLoading(true);
    const result = await dispatch(approvalExpressInterest({ bookingId: bookingId, isAccept: true }));
    setIsLoading(false);
    if (result.payload) {
      setReload && setReload(true);
    }
  }

  const onConfirmRejectInterest = async () => {
    setShowConfirmReject(false);
    setIsLoading(true);
    const result = await dispatch(approvalExpressInterest({ bookingId: bookingId, isAccept: false }));
    setIsLoading(false);
    if (result.payload) {
      setReload && setReload(true);
    }
  }

  return (
    <Box
      className={classes.wrapTag}
      style={{
        borderColor: isCalendar && bookingColor[bookingStatus] ? bookingColor[bookingStatus].border : '',
        backgroundColor: (isCalendar || isCancel) && bookingColor[bookingStatus] ? bookingColor[bookingStatus].background : ''
      }}
    >
      <Box className={isMobile && (isBookingPopup || isSearching)? classes.tagBodyMobile : classes.tagBody}>
        <Box className={classes.wrapAvatar}>
          <Avatar alt={name} src={imgSrc} className={classes.large} />
        </Box>
        <Box className={classes.wrapInfo}>
          {isApplied && renderTagApplied()}
          {isCalendar && renderTagCalendar()}
          {(isSearching || isBooking) && renderTagSearching()}
          {isCancel && renderTagCancel()}
          {isEndBooking && renderTagEndBooking()}
        </Box>
      </Box>
      <Box display="flex" justifyContent="center" marginTop="0.5rem">
        {isApplied && (
          <React.Fragment>
            <AppButton
              label={`${t("button.delete")}`}
              mode="outlined"
              buttonColor={AppColor.pink}
              onClick={onClickRemoveWorker}
              disabled={isDisable}
              className="mr-1"
            />
            <CopyToClipboard
              text={`${url}public/worker-profile/${id}`}
              onCopy={_getLink}
              mode="outlined"
            >
              <AppButton
                label={t('button.get_link')}
                buttonColor={AppColor.mainColor}
              />
            </CopyToClipboard>
          </React.Fragment>
        )}
      </Box>
      <AppConfirmDialog
        open={showConfirmRemove}
        onConfirm={onConfirmRemoveWorker}
        onClose={() => setShowConfirmRemove(false)}
        title={t('title.jobRemoveWorker')}
        content={t('text.jobRemoveWorker')}
      />
      <AppConfirmDialog
        open={showConfirmCancel}
        onConfirm={onConfirmCancelBooking}
        onClose={() => setShowConfirmCancel(false)}
        title={t('title.cancelBooking')}
        content={t('text.cancelBooking')}
      />
      <AppConfirmDialog
        open={showConfirmEndBooking}
        onConfirm={onConfirmEndBooking}
        onClose={() => setShowConfirmEndBooking(false)}
        title={t('title.endBooking')}
        content={t('text.endBooking')}
      />
      <AppConfirmDialog
        open={showConfirmApprove}
        onConfirm={onConfirmApproveInterest}
        onClose={() => setShowConfirmApprove(false)}
        title={t('title.approveInterest')}
        content={t('text.approveInterest')}
      />
      <AppConfirmDialog
        open={showConfirmReject}
        onConfirm={onConfirmRejectInterest}
        onClose={() => setShowConfirmReject(false)}
        title={t('title.rejectInterest')}
        content={t('text.rejectInterest')}
      />
    </Box>
  );
}

JobUserTag.propTypes = {
  userInfo: PropTypes.object,
  isSchedule: PropTypes.bool,
  allowViewProfile: PropTypes.bool,
  isApplied: PropTypes.bool,
  isSearching: PropTypes.bool,
  isBooking: PropTypes.bool,
  isBooked: PropTypes.bool,
  isCalendar: PropTypes.bool,
  onAdd: PropTypes.func,
  onRemove: PropTypes.func,
  shiftType: PropTypes.bool,
  isCancel: PropTypes.bool,
  setReload: PropTypes.func,
  isDisableButtonBook: PropTypes.bool,
  isDisable: PropTypes.bool,
  isEndBooking: PropTypes.bool,
  bookingInfo: PropTypes.any,
  isBookingPopup: PropTypes.bool,
};

export default JobUserTag;
